(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["meatgo-cart-flight"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('meatgo-cart-flight')) {
    customElements.define('meatgo-cart-flight', class extends HTMLElement {
      connectedCallback() {
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.sequence = 0;
        this.productPageCache = new Map();
        this.onAdded = this.onAdded.bind(this);
        this.onPrefetch = this.onPrefetch.bind(this);
        this.onVisibility = () => { if (document.hidden) this.clear(); };
        this.onMotion = () => { if (this.motion.matches) this.clear(); };
        this.onPageHide = () => this.clear();
        document.addEventListener('product-ajax:added', this.onAdded);
        document.addEventListener('pointerover', this.onPrefetch, { passive: true });
        document.addEventListener('touchstart', this.onPrefetch, { passive: true });
        document.addEventListener('visibilitychange', this.onVisibility);
        window.addEventListener('pagehide', this.onPageHide);
        this.motion.addEventListener('change', this.onMotion);
      }

      disconnectedCallback() {
        document.removeEventListener('product-ajax:added', this.onAdded);
        document.removeEventListener('pointerover', this.onPrefetch);
        document.removeEventListener('touchstart', this.onPrefetch);
        document.removeEventListener('visibilitychange', this.onVisibility);
        window.removeEventListener('pagehide', this.onPageHide);
        this.motion.removeEventListener('change', this.onMotion);
        this.clear();
        this.productPageCache?.clear();
      }

      clear() {
        this.sequence += 1;
        if (this.flight) this.flight.cancel();
        if (this.pulseAnimation) this.pulseAnimation.cancel();
        if (this.sprite) this.sprite.remove();
        this.flight = null;
        this.pulseAnimation = null;
        this.sprite = null;
      }

      visibleRect(element) {
        if (!(element instanceof Element)) return null;
        const rect = element.getBoundingClientRect();
        if (!rect.width || !rect.height || rect.bottom <= 0 || rect.top >= innerHeight ||
          rect.right <= 0 || rect.left >= innerWidth) return null;
        return rect;
      }

      pulse(cart) {
        const icon = cart.querySelector('svg') || cart;
        this.pulseAnimation = icon.animate(
          [{ transform: 'scale(1)' }, { transform: 'scale(1.15)' }, { transform: 'scale(1)' }],
          { duration: 220, easing: 'ease-out' }
        );
      }

      getItem(detail) {
        const items = Array.isArray(detail.product?.items) ? detail.product.items : [detail.product];
        const variantId = detail.form?.querySelector('[name="id"]')?.value;
        return items.find(item => item && variantId && String(item.variant_id || item.id) === String(variantId)) ||
          items.find(Boolean) || null;
      }

      getCardProductUrl(trigger) {
        const card = trigger?.closest?.('.product-card');
        if (!card) return '';
        const link = card.querySelector('a[href*="/products/"]');
        if (!link?.href) return '';
        try {
          const url = new URL(link.href, window.location.origin);
          url.searchParams.delete('variant');
          return url.toString();
        } catch (error) {
          return '';
        }
      }

      getRemoteFlightImage(trigger) {
        const url = this.getCardProductUrl(trigger);
        if (!url) return Promise.resolve('');

        let key = url;
        try {
          const parsed = new URL(url);
          key = `${parsed.pathname}${parsed.search}`;
        } catch (error) {
        }

        if (this.productPageCache.has(key)) return this.productPageCache.get(key);

        const request = fetch(url, { credentials: 'same-origin' })
          .then(response => response.ok ? response.text() : '')
          .then(html => {
            if (!html) return '';
            const page = new DOMParser().parseFromString(html, 'text/html');
            return page.querySelector('meatgo-cart-flight[data-product-flight-image]')?.dataset?.productFlightImage || '';
          })
          .catch(() => '');

        this.productPageCache.set(key, request);
        return request;
      }

      onPrefetch(event) {
        const target = event.target instanceof Element ? event.target : null;
        if (!target?.closest?.('.product-card')) return;
        this.getRemoteFlightImage(target);
      }

      async getSourceImage(detail, item) {
        const trigger = detail.submitter instanceof Element ? detail.submitter : detail.form;
        const card = trigger?.closest?.('.product-card');

        if (!card && this.dataset.productFlightImage) {
          return this.dataset.productFlightImage;
        }

        if (item && String(item.product_id) === this.dataset.gehaktProductId) {
          return this.dataset.gehaktImage;
        }

        if (card) {
          const transparentImage = await this.getRemoteFlightImage(trigger);
          if (transparentImage) return transparentImage;
        }

        const cardImage = card?.querySelector('.product-card__image--main img');
        if (cardImage) return cardImage.currentSrc || cardImage.src;

        const productRoot = trigger?.closest?.('product-info, .product, .main-product, [data-product-id]');
        const productImage = productRoot?.querySelector?.(
          '.product-media img, .product__media img, [data-media-id] img, .media-wrapper img'
        );
        if (productImage) return productImage.currentSrc || productImage.src;

        const featured = item?.featured_image;
        if (typeof featured === 'string' && featured) return featured;
        if (featured?.url) return featured.url;
        if (featured?.src) return featured.src;
        if (item?.image) return item.image;
        return '';
      }

      loadImage(url) {
        if (!url) return Promise.resolve(false);
        return new Promise(resolve => {
          const image = new Image();
          let settled = false;
          const finish = result => {
            if (settled) return;
            settled = true;
            clearTimeout(timer);
            resolve(result);
          };
          image.decoding = 'async';
          image.fetchPriority = 'high';
          image.onload = () => finish(true);
          image.onerror = () => finish(false);
          const timer = setTimeout(() => finish(false), 220);
          image.src = url;
          if (image.complete && image.naturalWidth) finish(true);
        });
      }

      async onAdded(event) {
        const detail = event.detail || {};
        const item = this.getItem(detail);
        if (!item) return;

        this.clear();
        if (this.motion.matches || document.hidden || !Element.prototype.animate) return;
        const sequence = this.sequence;

        const cart = Array.from(document.querySelectorAll('a.cart-drawer-button.cart-icon'))
          .find(element => this.visibleRect(element));
        if (!cart) return;

        const origin = this.visibleRect(detail.submitter) ||
          this.visibleRect(detail.form?.querySelector('[type="submit"]'));
        const target = this.visibleRect(cart.querySelector('svg')) || this.visibleRect(cart);
        const imageUrl = await this.getSourceImage(detail, item);

        if (sequence !== this.sequence || !this.isConnected || document.hidden || this.motion.matches) return;
        if (!origin || !target || !imageUrl) {
          this.pulse(cart);
          return;
        }

        const ready = await this.loadImage(imageUrl);
        if (sequence !== this.sequence || !this.isConnected || document.hidden || this.motion.matches) return;
        if (!ready) {
          this.pulse(cart);
          return;
        }

        const sprite = new Image();
        sprite.src = imageUrl;
        sprite.className = 'meatgo-cart-flight__sprite';
        sprite.alt = '';
        sprite.setAttribute('aria-hidden', 'true');
        sprite.draggable = false;

        const width = innerWidth < 750 ? 78 : 96;
        const height = width * 2 / 3;
        const start = {
          x: Math.min(innerWidth - width / 2, Math.max(width / 2, origin.left + origin.width / 2)),
          y: Math.min(innerHeight - height / 2, Math.max(height / 2, origin.top + origin.height / 2))
        };
        const end = { x: target.left + target.width / 2, y: target.top + target.height / 2 };
        const control = {
          x: start.x + (end.x - start.x) * 0.35,
          y: Math.max(height / 2, Math.min(start.y, end.y) - 90)
        };
        const frames = Array.from({ length: 17 }, (_, index) => {
          const t = index / 16;
          const x = (1 - t) ** 2 * start.x + 2 * (1 - t) * t * control.x + t * t * end.x;
          const y = (1 - t) ** 2 * start.y + 2 * (1 - t) * t * control.y + t * t * end.y;
          return {
            offset: t,
            transform: `translate3d(${x - width / 2}px, ${y - height / 2}px, 0) scale(${1 - 0.88 * t})`,
            opacity: t < 0.8 ? 1 : (1 - t) / 0.2
          };
        });

        sprite.style.transform = frames[0].transform;
        document.body.appendChild(sprite);
        this.sprite = sprite;
        this.flight = sprite.animate(
          frames,
          { duration: 560, easing: 'cubic-bezier(.25,.65,.35,1)', fill: 'forwards' }
        );

        try {
          await this.flight.finished;
          if (sequence === this.sequence && !this.motion.matches) this.pulse(cart);
        } catch (error) {
        } finally {
          sprite.remove();
          if (sequence === this.sequence) {
            this.sprite = null;
            this.flight = null;
          }
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["meatgo-whatsapp"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('meatgo-whatsapp')) {
    customElements.define('meatgo-whatsapp', class extends HTMLElement {
      connectedCallback() {
        this.lifecycle?.abort();
        this.lifecycle = new AbortController();
        this.toggle = this.querySelector('.mg-whatsapp__toggle');
        this.link = this.querySelector('.mg-whatsapp__link');
        if (!this.toggle || !this.link) return;
        const options = { signal: this.lifecycle.signal };
        this.mobile = window.matchMedia('(max-width: 767px)');
        this.toggle.addEventListener('click', () => this.setOpen(!this.hasAttribute('data-open')), options);
        this.mobile.addEventListener('change', () => this.setOpen(false), options);
        window.addEventListener('pageshow', () => this.setOpen(false), options);
        window.addEventListener('pagehide', () => this.setOpen(false), options);
        this.setOpen(false);
      }

      setOpen(open) {
        this.dismiss?.abort();
        open = Boolean(open && this.mobile.matches);
        this.toggleAttribute('data-open', open);
        this.toggle.setAttribute('aria-expanded', String(open));
        this.link.setAttribute('aria-hidden', String(!open));
        this.link.tabIndex = open ? 0 : -1;
        if (!open) return;
        this.dismiss = new AbortController();
        const options = { signal: this.dismiss.signal, passive: true };
        const outside = (event) => {
          if (!event.composedPath().includes(this)) this.setOpen(false);
        };
        document.addEventListener('pointerdown', outside, options);
        document.addEventListener('pointermove', (event) => {
          if (event.pointerType === 'touch') outside(event);
        }, options);
        document.addEventListener('touchmove', outside, options);
        document.addEventListener('scroll', () => this.setOpen(false), { ...options, capture: true });
        document.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const hadFocus = this.contains(document.activeElement);
          this.setOpen(false);
          if (hadFocus) this.toggle.focus({ preventScroll: true });
        }, options);
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.setOpen(false);
        }, options);
      }

      disconnectedCallback() {
        this.lifecycle?.abort();
        this.dismiss?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
